import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { multicast, takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { ClientAuthBO, functionpermission, GetAuthListBo, saveupdateAuthorizationBo } from '../client-parent.model';
import { ClientHttpService } from '../client-parent.service';
import { ClientAuthService } from './client-authorization.service';
import { AuthDateService } from './client-authorizationdateservice';
import { CommonHttpService } from 'src/app/common.service';
@Component({
  selector: 'app-client-authorization',
  templateUrl: './client-authorization.component.html',
  styleUrls: ['./client-authorization.component.scss']
})
export class ClientAuthorizationComponent implements OnInit {
  @Input() ClientAuth: ClientAuthBO = new ClientAuthBO();
  UpdateClientAuthList: any = [];
  ServiceBasedAuthType: any = [];
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridClientAuthorization') public gridClientAuthorization: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  PayerList: any = [];
  AuthTypeList: any = [];
  showAuthorizationErr: string;
  AuthorizationFilterBo: GetAuthListBo = new GetAuthListBo();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  SaveClientAuthList: saveupdateAuthorizationBo[] = [];
  public formatOptions: object;
  AuthFilter: string = "active";
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: true,
    editableDateField: true
  };
  FilterList: any = [];
  UpdateAuthForm: FormGroup;
  fp: functionpermission = new functionpermission();
  ICD10value: string = "client"
  ICD10List: [{ Key: string, Value: string }];
  icD10code: string = "";
  icD10Id: string = null;
  enableICD10: boolean = false;
  isDisabled: boolean = false;
  saveAuthorizationInfo: saveupdateAuthorizationBo = new saveupdateAuthorizationBo();
  authIndex;
  public dropdatas: string[] = ['yes', 'no'];
  public height = "220px";

  constructor(public global: GlobalComponent,
    public AuthlistService: AuthDateService,
    public dateservice: DateService,
    public formBuilder: FormBuilder,
    public datepipe: DatePipe,
    public ClientService: ClientHttpService,
    public CService: ClientAuthService, public toasterservice: ToastrService,
    public generalservice: GeneralService, public commonhttp: CommonHttpService) {
    this.global.checkforlogout();
console.log(this.ClientAuth,'ClientAuth')
    this.UpdateAuthForm = this.formBuilder.group({
      updatestartDate: [' ', Validators.required],
      updateendDate: [' ', Validators.required],
      updatePayer: [' ', Validators.required],
      updateRate: [' ', Validators.required],
      updateTotalHours: [' ', Validators.required],
      updateTotalnoofweeks: [' ', Validators.required],
      updateTotalAmount: [' ', Validators.required],
      updateCompany: [' ', Validators.required],
      updateinsuranceNo: [' ', [this.minLengthTrimmedValidator(2)]],
      authNote: [''],
      isTaxable: [],
      inActive: [false]

    })
    this.GridList = AuthlistService;
  }
  ngOnInit(): void {

    this.FilterList =
      [{ authid: "Active", authnames: 'Active' },
      { authid: "Expired", authnames: 'Expired' },
      { authid: "InActive", authnames: 'InActive' },
      { authid: "All", authnames: 'All' },
      ]
    this.AuthFilter = this.FilterList?.filter(a => a.authid == "Active")[0].authnames;

    this.filterSettings = {
      type: 'Menu',
    };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.showAuthorizationErr = "";
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.GetGroupPayorList();
    this.getAuthorizationdata();
    this.getAuthorizationType();
    this.GetCompanyNameDropdown();
    this.getpermission();
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Client");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.ClientService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  //.............................................PlusAuthorization....................................
  PlusAuthorization() {
    let authorization = new saveupdateAuthorizationBo();
    this.SaveClientAuthList.push(authorization);

  }
  //.............................................removeAuthorization....................................
  removeAuthorization(Index) {
    if (this.SaveClientAuthList.length > 1) {
      this.SaveClientAuthList.splice(Index, 1);
    }
  }
  //.............................................RefreshFilter....................................
  RefreshFilter() {
    this.AuthFilter = "Active";
    this.AuthorizationFilterBo.field = "payorName";
    this.AuthorizationFilterBo.matchCase = false;
    this.AuthorizationFilterBo.operator = "contains";
    this.AuthorizationFilterBo.value = "";
    this.AuthorizationFilterBo.type = "string";
    this.AuthorizationFilterBo.orderColumn = "payorName"
    this.gridClientAuthorization.pageSettings.currentPage = 1;
    this.getAuthorizationdata();
    this.gridClientAuthorization.clearSorting();
    this.gridClientAuthorization.clearFiltering();
  }
  //.............................................getAuthorizationdata....................................
  getAuthorizationdata() {
    if (this.AuthFilter == "Active") {
      this.AuthorizationFilterBo.state = "active";
    }
    else if (this.AuthFilter == "Expired") {
      this.AuthorizationFilterBo.state = "expired";
    }
    else if (this.AuthFilter == "InActive") {
      this.AuthorizationFilterBo.state = "inactive";
    }
    else {
      this.AuthorizationFilterBo.state = "all";
    }
    this.getAuthorizationFilter();
  }
  // ................................................dataChangeAuthorization..............................................
  public dataChangeAuthorization(CAuth): void {
    let val = (CAuth.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((CAuth.sorted || []).length) {
        this.AuthorizationFilterBo.orderColumn = CAuth.sorted[0].name;
        this.AuthorizationFilterBo.orderType = CAuth.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && CAuth.action.action != "clearFilter") {
      this.AuthorizationFilterBo.value = CAuth.action.currentFilterObject.value;
      this.AuthorizationFilterBo.field = CAuth.action.currentFilterObject.field;
      this.AuthorizationFilterBo.matchCase = CAuth.action.currentFilterObject.matchCase;
      this.AuthorizationFilterBo.operator = CAuth.action.currentFilterObject.operator;
      if(this.AuthorizationFilterBo.type == 'number'){
        this.AuthorizationFilterBo.type = (this.AuthorizationFilterBo.value != null && this.AuthorizationFilterBo.value != undefined)
        ? this.AuthorizationFilterBo.value.toString() : null;
      }
      if(this.AuthorizationFilterBo.field == 'totalAmt' || this.AuthorizationFilterBo.field == 'rate' || this.AuthorizationFilterBo.field == 'usedAmt' || this.AuthorizationFilterBo.field == 'remainingAmt' 
        || this.AuthorizationFilterBo.field == 'totalRemainingHours' || this.AuthorizationFilterBo.field == 'totalRemainingHoursPerDay' || this.AuthorizationFilterBo.field == 'totalRemainingHoursPerWeek'
      ){
        this.AuthorizationFilterBo.type = 'decimal';
      }
      if(this.AuthorizationFilterBo.field == 'isTaxable'){
        this.AuthorizationFilterBo.value = (this.AuthorizationFilterBo.value == 'yes')? "true": "false";
      }
    }
    else {
      if (val == "filtering" && CAuth.action.action == "clearFilter") {
        this.AuthorizationFilterBo.field = "payorName";
        this.AuthorizationFilterBo.matchCase = false;
        this.AuthorizationFilterBo.operator = "contains";
        this.AuthorizationFilterBo.value = "";
        this.AuthorizationFilterBo.type = "string";
      }
    }
    if(this.AuthorizationFilterBo.type != 'string' && (this.AuthorizationFilterBo.value == null || this.AuthorizationFilterBo.value == '' || this.AuthorizationFilterBo.value == undefined)){
      this.AuthorizationFilterBo.field = "payorName";
      this.AuthorizationFilterBo.matchCase = false;
      this.AuthorizationFilterBo.operator = "contains";
      this.AuthorizationFilterBo.value = "";
      this.AuthorizationFilterBo.type = "string";
      if(val == 'filtering') this.toasterservice.error('Please Enter Valid Input');
    }
    this.getAuthorizationFilter();
    if (val == "paging" && CAuth.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }
  //.........................................onActionAuthorization.....................................................
  public onActionAuthorization(CAuth) {
    this.AuthorizationFilterBo.currentpageno = this.gridClientAuthorization.pagerModule.pagerObj.currentPage;
    this.AuthorizationFilterBo.pageitem = this.gridClientAuthorization.pagerModule.pagerObj.pageSize;
    if (CAuth.name == "actionBegin" && CAuth.requestType == "filterbeforeopen") {
      this.AuthorizationFilterBo.type = CAuth.columnType
    }
  }
  //.............................................clearAuthorization....................................
  clearAuthorization(I) {
    this.SaveClientAuthList[I] = new saveupdateAuthorizationBo();
  }
  //............................................GetGroupPayorList................................................
  GetGroupPayorList() {
    this.CService.GetGroupPayorList().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.PayerList = data;
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  //..............................................getAuthorizationType.................................
  getAuthorizationType() {
    let params = new URLSearchParams();
    params.append("ListCode", "AUTHORIZATIONTYPE");
    this.CService.getLovTypes(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.AuthTypeList = data;
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  //............................................getDetails....................................................
  getDetails(saveBos: saveupdateAuthorizationBo) {
    this.saveAuthorizationInfo = JSON.parse(JSON.stringify(saveBos));
    
    
    setTimeout(() => {
      this.saveAuthorizationInfo.startDate = this.datepipe.transform(saveBos.startDate, "MM/dd/yyyy");
      this.saveAuthorizationInfo.endDate = this.datepipe.transform(saveBos.endDate, "MM/dd/yyyy");
      this.saveAuthorizationInfo.authTypelid = saveBos.authTypelid;
      // this.saveAuthorizationInfo.authNote = saveBos.authNote;
    }, 300);
    this.ChangeServiceBasedAuth('edit');
    this.CalculateTotalAmount('', 'update');
    this.saveAuthorizationInfo.isTaxable=String(this.saveAuthorizationInfo.isTaxable) == 'YES'|| this.saveAuthorizationInfo.isTaxable==true?true:false;
    this.UpdateAuthForm.get('isTaxable')?.setValue(this.saveAuthorizationInfo.isTaxable);    
    
  }

  ChangeServiceBasedAuth(check) {
    if (check == 'change') {
      this.saveAuthorizationInfo.serviceId = null;
    }
    this.GetServiceDropdownBasedonAuthType();
  }
  //..............................................ServiceDropdownBasedonAuthType.................................
  GetServiceDropdownBasedonAuthType() {
    let params = new URLSearchParams();
    params.append("AuthTypeLid", this.saveAuthorizationInfo.authTypelid);
    this.CService.GetServiceDropdownBasedonAuthType(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.ServiceBasedAuthType = data;
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  companyList: any
  GetCompanyNameDropdown() {

    this.CService.getCompanyDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.companyList = data;
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  //...........................................servicebasedAuthforNewAuthorization......................................
  servicebasedAuthforNewAuthorization(authitems, AuthorizationIndex) {
    if (authitems.authTypelid != "" && authitems.authTypelid != undefined && authitems.authTypelid != null) {
      this.SaveClientAuthList[AuthorizationIndex].icD10Code = this.global.globalclientdata.icD10Code != null && this.global.globalclientdata.icD10Code != undefined
      && this.global.globalclientdata.icD10Code != "" ? this.global.globalclientdata.icD10Code : this.icD10code;
      this.SaveClientAuthList[AuthorizationIndex].icD10Id = this.global.globalclientdata.icD10Id != null && this.global.globalclientdata.icD10Id != undefined
      && this.global.globalclientdata.icD10Id != "" && this.global.globalclientdata.icD10Id != "00000000-0000-0000-0000-00000000000" ? this.global.globalclientdata.icD10Id : this.icD10Id;
      let params = new URLSearchParams();
      params.append("AuthTypeLid", authitems.authTypelid);
      this.CService.GetServiceDropdownBasedonAuthType(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
        authitems.ServiceArrayList = data;
      }, (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
    }
    else {
      this.SaveClientAuthList[AuthorizationIndex].serviceId = null;
    }
  }
  //.........................................getLovFilter.............................................
  getAuthorizationFilter() {
    this.AuthorizationFilterBo.clientId = this.ClientAuth.Id;
    this.AuthlistService.execute(this.AuthorizationFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridClientAuthorization.height = '500';
        data?.result?.forEach(element => {
          if (element.isTaxable == true) {
            element.isTaxable = 'YES'
          } else if (element.isTaxable == false) {
            element.isTaxable = 'NO'
          }


        });
      }
      else {
        this.gridClientAuthorization.height = 'auto';
        data?.result?.forEach(element => {
          if (element.isTaxable == true) {
            element.isTaxable = 'YES'
          } else if (element.isTaxable == false) {
            element.isTaxable = 'NO'
          }


        });
      }
      
      data?.result?.forEach((element: any) => {
        element.totalHoursCalculated = (element.totalhours != null && element.totalNoWeeksOrMonths != null)
          ? element.totalhours * element.totalNoWeeksOrMonths
          : null;
        if(element.authTypeName.trim().toUpperCase() == "SERVICE")
        {
      element.totalRemainingHoursPerDay = formatHourMin(element.totalRemainingHoursPerDay);
      element.totalRemainingHoursPerWeek = formatHourMin(element.totalRemainingHoursPerWeek);
        }
     });

     function formatHourMin(value: any): string {
      if (value === null || value === undefined) return '';

      // If already formatted, return as-is
      if (typeof value === 'string' && value.includes('h')) {
        return value;
      }

      const str = value.toString();

      if (!str.includes('.')) {
        return `${str} h 0 min`;
      }

      const parts = str.split('.');
      const hours = parts[0];
      const minutes = parts[1].padEnd(2, '0').substring(0, 2); // ensure 2 digits

      return `${hours} h ${minutes} min`;
}
    })
  }
  
  //..............................CalculateTotalAmount.........................................
  CalculateTotalAmount(authrecords, type) {
    if (type == 'save') {
      if (authrecords.rate != 0 && authrecords.rate != undefined && authrecords.rate != null
        && authrecords.totalhours != 0 && authrecords.totalhours != null && authrecords.totalhours != undefined
        && authrecords.totalNoWeeksOrMonths != 0 && authrecords.totalNoWeeksOrMonths != null && authrecords.totalNoWeeksOrMonths != undefined
      ) {
        authrecords.usedAmt = parseFloat((authrecords.rate * authrecords.totalhours * authrecords.totalNoWeeksOrMonths).toFixed(2));
      }
      else {
        authrecords.usedAmt = null;
      }
    }
    else if (type == 'update') {
      if (this.saveAuthorizationInfo.rate != 0 && this.saveAuthorizationInfo.rate != undefined && this.saveAuthorizationInfo.rate != null
        && this.saveAuthorizationInfo.totalhours != 0 && this.saveAuthorizationInfo.totalhours != null && this.saveAuthorizationInfo.totalhours != undefined
        && this.saveAuthorizationInfo.totalNoWeeksOrMonths != 0 && this.saveAuthorizationInfo.totalNoWeeksOrMonths != null && this.saveAuthorizationInfo.totalNoWeeksOrMonths != undefined
      ) {
        this.saveAuthorizationInfo.usedAmt = parseFloat((this.saveAuthorizationInfo.rate * this.saveAuthorizationInfo.totalhours * this.saveAuthorizationInfo.totalNoWeeksOrMonths).toFixed(2));
      }
      else {
        this.saveAuthorizationInfo.usedAmt = null;
      }
    }
  }
  //..............................showAuthColumns.........................................
  showAuthColumns() {
    this.gridClientAuthorization.columnChooserModule.openColumnChooser(200, 50);
  }
  //.........................................allowonlyInteger.........................................
  allowonlyInteger(e) {
    if (
      // Allow: navigation keys: backspace, delete, arrows etc.
      (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
      (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
      (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
      (e.key === 'x' && e.metaKey === true) // Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  }

  keyPressForDecimal(event) {
    const key = event.key;
    const inputValue = event.target.value;
  
    const isDigit = this.global.isdigit(key);
    const isDecimalPoint = key === ".";
  
    if (!isDigit && !isDecimalPoint) {
      event.preventDefault();
      return;
    }

    if (isDecimalPoint) {
      if (inputValue.includes(".")) {
        event.preventDefault(); 
      }
    } else {
      const decimalIndex = inputValue.indexOf(".");
      if (decimalIndex !== -1 && inputValue.length - decimalIndex - 1 >= 2) {
        event.preventDefault();
      }
    }
  }
  
  //.......................................DateFormat.................................................
  DateFormat(event, type, name, Authindex) {
    if (type == "inputchanged") {
      if (name == 'SaveStartDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.SaveClientAuthList[Authindex].startDate = element;
        }
      }
      if (name == 'SaveEndDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.SaveClientAuthList[Authindex].endDate = element;
        }
      }

      if (name == 'UpdateStartDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.saveAuthorizationInfo.startDate = element;
        }
      }
      if (name == 'UpdateEndDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.saveAuthorizationInfo.endDate = element;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'SaveStartDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.SaveClientAuthList[Authindex].startDate = element;
        }
      }
      if (name == 'SaveEndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.SaveClientAuthList[Authindex].endDate = element;
        }
      }
      if (name == 'UpdateEndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.saveAuthorizationInfo.endDate = element;
        }
      }
    }
  }
  taxchange(val, val1) {
  }
  //.............................................CheckClientAuthorizationValidation.............................
  CheckClientAuthorizationValidation(AuthList: any = []) {
    this.isDisabled=true;
    this.showAuthorizationErr = "";
    AuthList.forEach(element => {
      if (this.showAuthorizationErr == "") {
        if (element.startDate == null || element.startDate == '' || element.startDate == undefined) {
          this.showAuthorizationErr = "Please Enter Start Date";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.endDate == null || element.endDate == undefined || element.endDate == '') {
          this.showAuthorizationErr = "Please Enter End Date";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.groupPayorId == null || element.groupPayorId == undefined || element.groupPayorId == '') {
          this.showAuthorizationErr = "Please Enter Payer";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.authTypelid == null || element.authTypelid == undefined || element.authTypelid == '') {
          this.showAuthorizationErr = "Please Enter Auth Type";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.serviceId == null || element.serviceId == undefined || element.serviceId == '') {
          this.showAuthorizationErr = "Please Enter service";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.rate == null || element.rate == undefined || element.rate == '') {
          this.showAuthorizationErr = "Please Enter Rate";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.totalhours == null || element.totalhours == undefined || element.totalhours == '') {
          this.showAuthorizationErr = "Please Enter Total Hours";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.totalNoWeeksOrMonths == null || element.totalNoWeeksOrMonths == undefined || element.totalNoWeeksOrMonths == '') {
          this.showAuthorizationErr = "Please Enter Total number of weeks";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.companyId == null || element.companyId == undefined || element.companyId == '') {
          this.showAuthorizationErr = "Please Select Company";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.insuranceNumber == null || element.insuranceNumber == undefined || element.insuranceNumber == '') {
          this.showAuthorizationErr = "Please Enter Insurance number";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if(element.insuranceNumber?.trim().length < 2) {
           this.showAuthorizationErr = "Enter at least 2 characters for the insurance number.";
          this.isDisabled=false;
          this.toasterservice.error(this.showAuthorizationErr);
        }
        else if (element.startDate != null && element.startDate != undefined && element.startDate != ''
          && element.endDate != null && element.endDate != undefined && element.endDate != '') {
          if (new Date(element.startDate).getTime() > new Date(element.endDate).getTime()) {
            this.showAuthorizationErr = "End date must be larger than start date";
            this.isDisabled=false;
            this.toasterservice.error(this.showAuthorizationErr);
          }
        }
        setTimeout(() => {
          this.showAuthorizationErr = ""
        }, 2000);
      }
    });
    if (this.showAuthorizationErr == "") {
      this.SaveClientAuth(AuthList);
    }
  }
  //...........................................................SaveClientAuth...................................
  SaveClientAuth(AuthList) {
    let AuthValue = JSON.parse(JSON.stringify(AuthList));
    AuthValue.forEach(element => {
      element.id = element.id;
      element.startDate = this.global.getDateTimeString(element.startDate);
      element.endDate = this.global.getDateTimeString(element.endDate);
      element.authTypelid = element.authTypelid;
      element.groupPayorId = element.groupPayorId;
      element.serviceId = element.serviceId;
      element.serviceDescription = null;
      element.totalhours = element.totalhours;
      element.totalNoWeeksOrMonths = element.totalNoWeeksOrMonths;
      element.rate = element.rate;
      element.usedAmt = element.usedAmt;
      element.doesPtoApply = false;
      element.payrollTaxApply = false;;
      element.clientId = this.ClientAuth.Id;
      element.isCreate = false;
      element.icD10code = element.icD10code;
      element.icD10Id = element.icD10Id;
    });
    this.CService.SaveClientAuth(AuthValue).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isDisabled=false;
      this.toasterservice.success('Authorization saved successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('openSaveModal').click();
      this.SaveClientAuthList = [];
      this.getAuthorizationFilter();
    }, (err: any) => {
      this.isDisabled=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  //.................................................UpdateClientAuth.......................................
  UpdateClientAuth() {
    this.isDisabled=true;
    console.log(this.saveAuthorizationInfo, "bbbbbbbbbbbbb")
    let updateAuth = JSON.parse(JSON.stringify(this.saveAuthorizationInfo));
    console.log(updateAuth, 'authupdate');
    this.UpdateClientAuthList = []
    updateAuth.id = this.saveAuthorizationInfo.id;
    // updateAuth.authNote = this.saveAuthorizationInfo.authNote;
    updateAuth.clientId = this.saveAuthorizationInfo.clientId;
    updateAuth.startDate = this.global.getDateTimeString(this.saveAuthorizationInfo.startDate);
    updateAuth.endDate = this.global.getDateTimeString(this.saveAuthorizationInfo.endDate);
    updateAuth.rate = parseFloat(this.saveAuthorizationInfo.rate.toString());
    updateAuth.totalhours = parseInt(this.saveAuthorizationInfo.totalhours.toString());
    updateAuth.totalNoWeeksOrMonths = parseInt(this.saveAuthorizationInfo.totalNoWeeksOrMonths.toString());
    updateAuth.usedAmt = parseInt(this.saveAuthorizationInfo.usedAmt.toString());
    updateAuth.icd
    this.UpdateClientAuthList.push(updateAuth)
    this.CService.updateClientAuth(this.UpdateClientAuthList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isDisabled=false;
      this.toasterservice.success('Authorization updated successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('openUpdateModal').click();
      this.getAuthorizationFilter();
      this.UpdateClientAuthList = [];
      this.saveAuthorizationInfo = new saveupdateAuthorizationBo();
      console.log(this.saveAuthorizationInfo, "bbbbbbbbbbbbb")

    }, (err: any) => {
      this.isDisabled=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  //..........................................................clearModal.................................
  clearModal() {
    this.SaveClientAuthList = [];
  }
  //======================================Data from ICD10================================================//
  ICD10data(event) {
    this.icD10Id = event?.id.toString();
    this.icD10code = event?.code.toString();
    this.saveAuthorizationInfo.icD10Code = this.icD10code;
    this.saveAuthorizationInfo.icD10Id = this.icD10Id;
    document.getElementById("ICD10eopen").click();
    this.enableICD10 = false;
    if(this.SaveClientAuthList?.length > 0) {
      this.SaveClientAuthList[this.authIndex].icD10Code = this.icD10code;
      this.SaveClientAuthList[this.authIndex].icD10Id = this.icD10Id;
    }
  }
  //=========================================close ICD10================================================================//
  Closedcdialog() {
    document.getElementById("ICD10eopen").click();
  }
  
  getAuthIndex(index) {
   this.authIndex = index;
  }
   minLengthTrimmedValidator(minLength: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').trim();
    if (value.length === 0) return { required: true }; // whitespace only
    if (value.length < minLength) return { minlengthtrim: { requiredLength: minLength, actualLength: value.length } };
    return null;
  };
}
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

 
}
